export default {
  201: 'Usuario creado con éxito',
  404: 'Usuario no encontrado',
  406: 'Archivo no encontrado',
  410: 'El empleado no existe',
  427: 'Ya existe un usuario con el ID o correo electrónico ingresado. Favor de validar.',
  428: 'No tienes autorización para borrar este usuario mientras esté activo.',
  446: 'Este usuario no puede ser eliminado porque cuenta con contratos activos.',
};
